<template>
  <v-card>
    <v-card-title class="justify-center">
        <span v-if="formType == 'addForm' " class="text-h5">{{ $t('Add Payment') }}</span>
        <span v-if="formType == 'editForm' " class="text-h5">{{ $t('Edit Payment') }}</span>
    </v-card-title>
    <v-card-text>
      <v-container>
          <v-form>
            <v-row>
              <v-col
                cols="12"
                sm="2"
              >
                <v-text-field 
                  v-if="(expense.project_work_id === null && formType == 'addForm') || formType == 'editForm'"
                  :label="$t('Work Perform Value (mLAK)')"
                  required
                  type="number"
                  v-model="expense.work_value"
                  :hint="$t('Mandatory')"
                  :rules="numberRules"
                  persistent-hint
                ></v-text-field>
                <div v-if="expense.project_work_id !== null && formType == 'addForm'">
                  <p class="font-weight-light">{{ $t('Work Perform Value (mLAK)') }}</p>
                  <p class="text-h4 text--primary">{{ expense.work_value }}</p>
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="2"
              >
                <v-select
                    v-if="formType == 'addForm' || formType == 'editForm'"
                    v-model="expense.funding_source_id"
                    :items="projectFundingSourceList"
                    :item-value="item=>item.id"
                    :item-text="item=>item.translation.name"
                    :label="$t('Budget Source')"
                    :hint="$t('Mandatory')"
                    :rules="selectRules"
                    persistent-hint
                  >
                    <template v-slot:item="{ item }">
                      <div>{{ item.translation.name }}</div>
                    </template>
                  </v-select>
              </v-col>
              <v-col
                cols="12"
                sm="2"
              >
                <v-text-field 
                  v-if="formType == 'addForm' || formType == 'editForm'"
                  :label="$t('Payment Value (mLAK)')"
                  required
                  type="number"
                  v-model="expense.expense_amount"
                  :hint="$t('Mandatory')"
                  :rules="numberRules"
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="3"
              >
                <v-file-input 
                  v-if="formType == 'addForm' || formType == 'editForm'"
                  :label="$t('Upload Payment certificate')"
                  v-model="expense.expense_document"
                  :hint="$t('Mandatory')"
                  :rules="fileRules"
                  persistent-hint
                >
                  <template slot="append">{{expense.document_name }}</template>
                </v-file-input>
              </v-col>
            </v-row>
          </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        class="close-button"
        text
        v-on:click="close()"
      >
        {{ $t('Close') }}
        <v-dialog v-model="dialog_modal_message" persistent max-width="800px" :retain-focus="false">
          <MessageAlert 
              v-if="dialog_modal_message" 
              :messageProps="$store.state.messages.close" 
              :cancelProps="$store.state.messages.no" 
              :validationProps="$store.state.messages.yes" 
              :dialog.sync="dialog_modal_message" 
              @answerModal="getModalAnswer"
          />
        </v-dialog>
      </v-btn>
      <v-btn
        color="white darken-1"
        style="background-color:#31c0be;"
        text
        v-on:click="save()"
        v-if="expense
              && expense.expense_document 
              && expense.funding_source_id
              && expense.work_value > 0
              && expense.expense_amount > 0"
      >
        {{ $t('Save') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: 'ExpenseForm',
    props: {
      formType: {
        type: String
      },
      expense: {
        type: Object
      },
    },
    data: () => ({
      dialog_modal_message: false
    }),
    computed: {
      projectFundingSourceList() {
        return this.$store.state.projects.projectFundingSourceList;
      },
    },
    created: function(){
      //https://v15.vuetifyjs.com/en/components/forms/ 
      this.numberRules = [ v => v > 0 || this.getTranslation('Positive Number is required') ];
      this.selectRules = [ v => !!v || this.getTranslation('At least 1 Information is required') ];
      this.fileRules = [ v => !!v || this.getTranslation('File is required'), v => (v && v.size > 0) || this.getTranslation('File is required'), ];
    },
    mounted: function(){
      this.expense.project_id = this.expense.project_id;
      if(this.expense.project_work_id !== null){
        this.expense.work_value = this.expense.project_work.work_value;
      }
      if(this.formType === 'editForm'){
        this.expense.funding_source_id = this.expense.expense.funding_source_id;
        this.expense.expense_amount = this.expense.expense.expense_amount;
        this.expense.document_name = this.expense.expense.document_name;
      }

      this.$store.dispatch('projects/getProjectFundingSourceList',this.expense);
      /*if(this.formType === 'editForm' && !this.expense.project_budget_id){ //because we don't managed exactly what fund of the other funding 
        this.expense.project_budget_id = 2;
      }*/
    },
    methods: {
      getTranslation(val) {
        return this.$t(val);
      },
      close: function(){
        //this.$store.dispatch('projects/getProjectCompletedList');
        this.dialog_modal_message = true;
        //this.$store.dispatch('projects/getProjectOnGoingList');
        //this.$emit('update:dialog', false)
      },
      getModalAnswer(value){
        if(value){
          this.$store.dispatch('projects/getProjectOnGoingList');
          this.$emit('update:dialog', false)
        }
      },

      save: function(){
        if(this.formType === 'addForm'){

          if(this.expense.expense_document){
            let form = new FormData();
            form.append("expense_document", this.expense.expense_document);
            form.append("name", this.expense.expense_document.name);
            form.append("project_id", this.expense.project_id);
            var expense_doc = {
              'file': form.get("expense_document"),
              'name': form.get("name"),
              'project_id': form.get("project_id"),
              'document_category_id': 20
            }
            this.expense.document_name = this.expense.expense_document.name; //TEMPORARY
            this.$store.dispatch('projects/addExpenseDocument', expense_doc);
          }

          //Affectation of the project_budget_id depending on the funding source selected
          //var project_budget_available = this.expense.project_budgets.filter((pb) => pb.funding_source_id === this.expense.project_budget_id);
          //this.expense.project_budget_id = project_budget_available[0].id;
            
          this.$store.dispatch('projects/addExpense',this.expense);
          this.$emit('update:dialog', false);
        }

        if(this.formType === 'editForm'){

          if(this.expense.expense_document){
            let form = new FormData();
            form.append("expense_document", this.expense.expense_document);
            form.append("name", this.expense.expense_document.name);
            form.append("project_id", this.expense.project_id);
            var expense_doc = {
              'file': form.get("expense_document"),
              'name': form.get("name"),
              'project_id': form.get("project_id"),
              'document_category_id': 20
            }
            this.expense.document_name = this.expense.expense_document.name; //TEMPORARY
          }
          this.$store.dispatch('projects/updateExpense',this.expense);
          this.$emit('update:dialog', false);

        }

        //this.$store.dispatch('projects/checkIfProjectCompleted',{id: this.expense.project_id});

        this.$store.dispatch('projects/getProjectOnGoingList');

      }
    }
  }
</script>